<template>
  <main id="strategy_detail" class="container">
    <div class="navigation">
      <!-- <Breadcrumb separator=">">
        <BreadcrumbItem> 作业详情</BreadcrumbItem>
        <BreadcrumbItem>作业文件详情</BreadcrumbItem>
      </Breadcrumb>-->
      <el-button @click="$router.go(-1)" class="fr" style="margin-top: 14px;">返回</el-button>
    </div>
    <div class="det_wrapper">
      <!-- <div class="strategy-desc card">
        <h2 class="title">{{ strategy.wstrStrategyName }}</h2>
        <div class="header">
          <span v-if="strategy.wstrFirstType" class="first-type">投资种类：{{ strategy.wstrFirstType }}</span>
          <span
            v-if="strategy.wstrSecondType"
            class="second-type"
          >投资类型：{{ strategy.wstrSecondType }}</span>
          <span class="date">更新时间：{{ strategy.ptLastUpdate | formatTime }}</span>
          <span v-if="strategy.userInfo" class="from fr">策略作者：{{ strategy.userInfo.userName }}</span>
        </div>
        <div class="content">
          <h3 class="title">策略说明：</h3>
          <p>{{ strategy.wstrRemark || "暂无说明" }}</p>
        </div>
        <div class="footer">
          <span class="count-view">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-icon_liulanliang" />
            </svg>
            {{ countData && countData.viewsCount }}
          </span>
          <span class="count-comt">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-icon_pinglun" />
            </svg>
            {{ countData && countData.commentsCount }}
          </span>
          <span class="count-dn">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-download" />
            </svg>
            {{ countData && countData.downloadsCount }}
          </span>
        </div>
      </div>-->
      <!-- 雷达图 -->
      <el-row class="radarsCen">
        <el-col :span="12">
          <h2 class="title">{{ policyData.wstrStrategyName }}</h2>
          <div class="header">
            <span
              v-if="policyData.wstrFirstType"
              class="first-type"
            >投资种类：{{ policyData.wstrFirstType }}</span>
            <span
              v-if="policyData.wstrSecondType"
              class="second-type"
            >投资类型：{{ policyData.wstrSecondType }}</span>
            <span class="date">更新时间：{{ policyData.ptLastUpdate | formatTime }}</span>
            <span v-if="policyData.userInfo" class="from fr">策略作者：{{ policyData.userInfo.userName }}</span>
          </div>
          <div class="content">
            <h3 class="title">策略说明：</h3>
            <p>{{ policyData.wstrRemark || "暂无说明" }}</p>
          </div>
        </el-col>
        <el-col :span="12">
          <div ref="echartRadars" style="width: 100%; height: 420px;"></div>
        </el-col>
      </el-row>
      <div class="strategy-profit card">
        <table>
          <thead>
            <tr>
              <th>年化收益率</th>
              <th>累计收益率</th>
              <th>初始资金</th>
              <th>总资产</th>
              <th>最大回撤率</th>
              <th>夏普比率</th>
              <th>起始时间</th>
              <th>结束时间</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                :style="{
                  color: strategy.dbAnnuReturnRate < 0 ? '#90ee90' : '#FF534E'
                }"
              >{{ ((strategy.dbAnnuReturnRate)*100).toFixed(2) }}%</td>
              <td
                :style="{
                  color: strategy.dbAccProfitP < 0 ? '#90ee90' : '#FF534E'
                }"
              >{{ ((strategy.dbAccProfitP)*100).toFixed(2) }}%</td>
              <td style="color:#FF534E;">{{ strategy.dbInitCash | toBit }}</td>
              <td style="color:#FF534E;">{{ strategy.dbTotalProperty | toBit }}</td>
              <td>{{((strategy.dbMaxDrawBackP)*100).toFixed(2)}}%</td>
              <td>{{((strategy.dbSharpeRatio)*100).toFixed(2)}}%</td>
              <td>{{ strategy.dtStart }}</td>
              <td>{{ strategy.dtEnd }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <div style="width:300px;height:300px;">
        <div ref="echartRadars" style="width:100%;height:100%;"></div>
      </div>-->
      <div class="strategy-trend card">
        <div id="echart_wrapper" ref="echart"></div>
      </div>
      <div class="strategy-code card clearfix">
        <div class="code-header">
          <ul class="tabs">
            <li class="tab" :class="{ active: codeIndex === 1 }" @click="getStrategyCode(1)">策略代码</li>
            <li class="tab" :class="{ active: codeIndex === 2 }" @click="getStrategyCode(2)">执行代码</li>
          </ul>
          <a v-if="fileName != ''" class="donwload" @click="donwload">
            <!-- :href="
              `${apiUrl}/cms/file/strategy/download/${bpSUserId}/${strategyId}/${
                codeIndex === 1 ? strategyFileName : strategyExeFileName
              }`
            "-->
            <!-- <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-download" />
            </svg>-->
            下载代码
          </a>
          <a v-else class="donwload" @click="handleNoCodeFile">
            <!-- <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-download" />
            </svg>-->
            下载代码
          </a>
        </div>
        <div class="code-content item-list">
          <pre class="item" :class="{ show: codeIndex === 1 }">{{
            strategyCode
          }}</pre>
          <pre class="item" :class="{ show: codeIndex === 2 }">{{
            strategyExeCode
          }}</pre>
        </div>
      </div>
      <!-- <div class="strategy-comment card">
        <comment :id="strategyId" type="strategy"></comment>
      </div>-->
    </div>

    <!-- <div class="aside_wrapper">
      <author-card v-if="authorId" :author-id="authorId" title="策略"></author-card>
      <at-download></at-download>
    </div>-->
  </main>
</template>
<script>
// import echarts from "echarts/lib/echarts";
import echarts from "echarts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/title";
import "echarts/lib/chart/line";

export default {
  components: {},
  /**
   * 过滤器
   */
  filters: {
    // 格式化时间
    formatTime(dateTime) {
      return dateTime ? dateTime.replace("T", " ") : "";
    },
    // 保留两位有效数字
    toBit(val, bit = 2) {
      return val && val === val ? (+val).toFixed(bit) : val;
    },
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem("USER")),
      policyData: {},
      // 作者id
      authorId: 0,
      // api地址
      apiUrl: "",
      // 策略拥有者id
      bpSUserId: "",
      // 策略id
      strategyId: this.$route.query.strategyId,
      // 策略信息对象
      strategy: {
        // 策略名称
        wstrStrategyName: "",
        // 投资种类
        wstrFirstType: "",
        // 投资类型
        wstrSecondType: "",
        // 更新时间
        ptLastUpdate: "",
        // 用户信息
        userInfo: {
          userName: "",
        },
      },
      // 统计数据
      countData: {
        // 浏览数
        viewsCount: 0,
        // 评论数
        commentsCount: 0,
        // 下载数
        downloadsCount: 0,
      },
      // 策略代码
      strategyCode: "",
      // 策略可执行代码
      strategyExeCode: "",
      // 策略代码文件名
      strategyFileName: "",
      // 策略可执行代码文件名
      strategyExeFileName: "",
      // 代码类型索引
      codeIndex: 1,
      // 当前下载对应的代码文件名
      fileName: "",
    };
  },
  mounted() {
    // 获取路由参数
    // this.apiUrl = process.env.VUE_APP_API;
    // const { bpSUserId, strategyId } = this.$route.query;
    // this.bpSUserId = bpSUserId;
    // this.strategyId = strategyId;
    // 获取策略详情数据
    // this.getStrategyByID();
    // 获取策略统计数据
    // this.getStrategyCountData();
    // 获取策略趋势数据
    // this.getStrategyTrend();
    this.getStrategyDetail();
    // this.$nextTick(function() {
    //   this.echartRadar();
    // });
    this.getStrategyInfo();
  },
  beforeDestroy() {
    // 销毁strategyChartInstance实例
    this.strategyChartInstance && this.strategyChartInstance.dispose();
    this.strategyChartInstance = null;
  },
  methods: {
    // 下载代码
    donwload() {
      //  `${apiUrl}/cms/file/strategy/download/${bpSUserId}/${strategyId}/${
      //           codeIndex === 1 ? strategyFileName : strategyExeFileName
      const param = {
        userId: this.$route.query.userid,
        strategyId: this.strategyId,
        fileName: this.fileName,
      };
      this.$api.allianceSchool.downloadSTCode(param).then((res) => {
        if (res) {
          let a = document.createElement("a");
          let blob = new Blob([res], { type: "application/vnd.ms-excel" });
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", this.fileName);
          a.click();
        }
      });
    },
    /**
     * 根据策略id获取数据
     */
    getStrategyByID() {
      this.$api.cms.strategy.getStrategyByID(this.strategyId).then((res) => {
        // 解析数据
        this.$util.strategy
          .resolveRes(res)
          .then(({ data }) => {
            // 获取策略数据
            const strategyPSTInfo = data.listPSTInfo[0];
            this.strategy = {
              ...this.strategy,
              userInfo: { ...strategyPSTInfo.userInfo },
              ...strategyPSTInfo.STinfo.strategyInfo,
              ...strategyPSTInfo.STinfo.uploadFileMd5,
            };

            // 获取策略代码文件名
            this.strategyFileName = this.strategy.wstrStrategyLogicFileName;
            this.strategyExeFileName = this.strategy.wstrRunBackScriptName;
            // 获取策略代码
            this.getStrategyCode(1);
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    // 获取策略统计数据
    getStrategyCountData() {
      this.$api.cms.strategy
        .getStrategyCountData(this.strategyId)
        .then((res) => {
          this.countData = res;
          this.authorId = res.uid;
        });
    },
    /**
     * 获取策略详情
     */
    getStrategyDetail() {
      const { bpSUserId, strategyId } = this;
      const param = {
        userId: this.$route.query.userid,
        strategyId: this.$route.query.strategyId,
      };
      // this.$api.cms.strategy
      //   .getStrategyDetail({
      //     bpSUserId,
      //     strategyId
      //   })
      //   .then(res => {
      this.$api.allianceSchool
        .getUstSTPerformance(param)
        .then((res) => {
          const {
            resolveRes,
            concreteCardData,
            configureOption,
          } = this.$util.strategy;
          // 解析数据
          resolveRes(res.data)
            .then(({ data }) => {
              data = data.listPriCloudStrategyDetailInfo[0].sPRAT3WholeInfo;
              // 具体化数据
              this.strategyTrend = concreteCardData(
                data.AT3Trend,
                data.AT3StrategyAna.AT3Summary
              );
              // 组装strategy
              // this.strategy = {
              //   ...this.strategyTrend,
              //   dbSharpeRatio: this.toPercent(
              //     data.AT3StrategyDetails.AT3StrategyInfo.dbSharpeRatio
              //   )
              // };
              this.strategy = {
                ...data.AT3StrategyAna.AT3Summary,
                ...data.AT3Trend.AT3BasicInfo,
                dbSharpeRatio:
                  data.AT3StrategyDetails.AT3StrategyInfo.dbSharpeRatio,
              };
              // 构建echart option参数
              const configureStrategyTrend = configureOption(
                this.strategyTrend
              );

              // 渲染图表
              this.renderStrategyTrend(configureStrategyTrend);
              // 渲染雷达图

              this.echartRadar(data.PRScore);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**
     * 渲染策略曲线
     */
    renderStrategyTrend(configureStrategyTrend) {
      this.strategyChartInstance = echarts.init(this.$refs["echart"]);
      this.strategyChartInstance.setOption(configureStrategyTrend);
    },
    // 雷达图
    echartRadar(PRScore) {
      var option = {
        title: {
          text: `综合评分:${Number(PRScore.dbStrategyScore).toFixed(2)}`,
        },
        tooltip: {
          trigger: "axis",
        },
        radar: [
          {
            indicator: [
              { text: "净收益能力", max: 100 },
              { text: "风险控制能力", max: 100 },
              { text: "超额收益能力", max: 100 },
              { text: "进攻能力", max: 100 },
              { text: "防御能力", max: 100 },
              { text: "选股能力", max: 100 },
              { text: "择时能力", max: 100 },
              { text: "稳定盈利", max: 100 },
            ],
            radius: 80,
          },
        ],
        series: [
          {
            type: "radar",
            tooltip: {
              trigger: "item",
            },

            areaStyle: {
              opacity: 0.9,
              color: new echarts.graphic.RadialGradient(0.5, 0.5, 1, [
                {
                  color: "#B8D3E4",
                  offset: 0,
                },
                {
                  color: "#72ACD1",
                  offset: 1,
                },
              ]),
            },
            data: [
              {
                value: [
                  Number(PRScore.dbNetProfitAbilityScore).toFixed(2),
                  Number(PRScore.dbRiskControlAbilityScore).toFixed(2),
                  Number(PRScore.dbExtraReturnAblityScore).toFixed(2),
                  Number(PRScore.dbAttackAbilityScore).toFixed(2),
                  Number(PRScore.dbDefenseAbilityScore).toFixed(2),
                  Number(PRScore.dbChoseObjectAbilityScore).toFixed(2),
                  Number(PRScore.dbChoseTimeAbilityScore).toFixed(2),
                  Number(PRScore.dbAnnuReturnScore).toFixed(2),
                ],
                name: `软件`,
              },
            ],
          },
        ],
      };
      const charts = echarts.init(this.$refs["echartRadars"]);
      charts.setOption(option);
    },

    getStrategyInfo() {
      this.$api.allianceSchool
        .getStrategyInfo(this.$route.query.strategyId)
        .then((res) => {
          if (res.errCode == 0) {
            const STinfo =
              res.data.msgBody.data.listPriCloudStrategyDetailInfo[0]
                .sPRAT3WholeInfo;
            this.policyData =
              res.data.msgBody.data.listPriCloudStrategyDetailInfo[0].sCloudStrategyInfo;
            // const STinfo = res.msgBody.data.listPSTInfo[0].STinfo
            // this.strategy = STinfo.strategyInfo;
            // this.strategy = res.msgBody.data.listPriCloudStrategyDetailInfo[0].sCloudStrategyInfo;
            // 获取策略代码文件名
            // this.strategyFileName = STinfo.uploadFileMd5.wstrStrategyLogicFileName;
            // this.strategyExeFileName =  STinfo.uploadFileMd5.wstrRunBackScriptName;
            this.strategyFileName =
              res.data.msgBody.data.listPriCloudStrategyDetailInfo[0].wstrStrategyScritpName;
            this.strategyExeFileName =
              res.data.msgBody.data.listPriCloudStrategyDetailInfo[0].wstrRealTimeScript;
            this.getStrategyCode(1);
          } else {
            this.$message.error(res.errMsg);
          }
        });
    },
    /**
     * 获取策略代码
     */
    getStrategyCode(codeIndex) {
      this.codeIndex = codeIndex;
      // 获取策略代码文件名
      const {
        bpSUserId,
        strategyId,
        strategyFileName,
        strategyExeFileName,
      } = this;
      // 代码类型
      const type = codeIndex === 1 ? "strategyCode" : "strategyExeCode";
      const fileName = codeIndex === 1 ? strategyFileName : strategyExeFileName;
      this.fileName = fileName;
      if (fileName == "") {
        this[type] = codeIndex === 1 ? "暂无策略代码" : "暂无可执行代码";
        return;
      }
      // this[type] ="function CSArb2(bInit,bDayBegin,cellPar)%\r\n%% 函数说明\r\n% 上面的三个参数是一种固定结构。\r\n% 当在调用该函数如 StrategyName(a1,a2,a3,a4,a5,...).所有的参数都会被赋值给cellPar，即cellPar={a1,a2,a3,a4,a5,...}\r\n% bInit,在策略逻辑运行前为1，类似优矿等平台的initialize函数。当开始判断是否下单后，该变量为0.\r\n% bDayBegin 在一天的第一根Bar为1，其他时刻为0\r\n\r\n%% 外部和全局参数声明,这是一个固定结构.\r\nglobal g_idxKDay; % 注册日数据的index.日数据是分钟数据的合成.如在日中获取，当日的数据仅是当日已出现数据的合成，不包含之后的数据。\r\nglobal g_idxSignal;\r\nFreq = cellPar{1};\r\n%% 初始化回测帐户\r\nif bInit\r\n % traderSetParalMode(false);%默认是true，因子计算函数并行执行，速度快，不能调试，false串行执行可以设断点调试\r\n g_idxKDay = traderRegKData('day',1);% 只有注册之后才能获取数据。分钟数据的获取方法为 traderRegKData('min',1)。后面的数字是刷新频率。\r\n g_idxSignal = traderRegUserIndi(@getSignal,{g_idxKDay}); %计算因子。调用需要函数如getRange，大括号内是输入参数\r\n %% 交易逻辑\r\nelse\r\n dataDay = traderGetRegKData(g_idxKDay,1,false);\r\n if isnan(dataDay(5,end))|| isnan(dataDay(13,end)) || dataDay(1,end) ~= dataDay(9,end)\r\n return\r\n end\r\n signal = traderGetRegUserIndi(g_idxSignal,1);\r\n targetList = traderGetTargetList(); % 获取标的信息。\r\n TLen = length(targetList);\r\n [mp,~,~]=traderGetAccountPositionV2(1,1:TLen);\r\n \r\n \r\n if signal(1,end)==1 && ((mp(2)>0 && mp(1)<0) || (mp(1)==0 && mp(2)==0))\r\n traderSellShortV2(1,2,1,0,'market','buy1');%开多单\r\n traderBuyV2(1,1,1,0,'market','buy1');%开多单\r\n elseif signal(1,end)==-1 && (( mp(2)<0 && mp(1)>0 ) || (mp(1)==0 && mp(2)==0))\r\n traderSellShortV2(1,1,1,0,'market','buy1');%开多单\r\n traderBuyV2(1,2,1,0,'market','buy1');%开多单\r\n elseif signal(1,end)==0\r\n if mp(1)~=0\r\n traderPositionToV2(1,1,0,0,'market','close');\r\n end\r\n if mp(2)~=0\r\n traderPositionToV2(1,2,0,0,'market','close');\r\n end\r\n end\r\n \r\nend\r\nend\r\n\r\n%% 计算因子的自定义函数\r\nfunction value=getSignal(cellPar,bpPFCell)\r\n%调用该函数的参数将会全部被赋给cellPar\r\n%bpPFCell为一个时间序列，标记特定的刷新时刻\r\n%%%参数声明\r\nidxK =cellPar{1};\r\n%%%函数计算\r\nvalue=nan;\r\nregKMatrix = traderGetRegKData(idxK,40,false,bpPFCell);\r\nregKMatrix(:,any(isnan(regKMatrix),1))=[];\r\nif isempty(regKMatrix)\r\n return\r\nend\r\nTime = intersect(regKMatrix(1,:),regKMatrix(9,:));\r\n[~,loc1] = ismember(Time,regKMatrix(1,:));\r\n[~,loc2] = ismember(Time,regKMatrix(9,:));\r\n\r\ncurrent_data = regKMatrix(1:8,loc1);\r\nnext_data = regKMatrix(9:end,loc2);\r\n[~,KLen]=size(current_data);\r\nif KLen < 30\r\n return\r\nend\r\nFit = polyfit(current_data(5,:),next_data(5,:),1);\r\nrsd1 = next_data(5,:)-current_data(5,:)*Fit(1)-Fit(2);\r\nw = rsd1(end)/std(rsd1,1);\r\n\r\nif w>.8 && w<2.5\r\n value(1)=1;\r\nelseif w<-.8 && w>-2.5\r\n value(1) = -1;\r\nelseif abs(w)>2.5 || abs(w)<.8\r\n value(1) = 0;\r\nend\r\nend\r\n"
      this.$api.allianceSchool
        .getSTCode({
          fileName,
          strategyId,
          userId: this.$route.query.userid,
          // userId: this.user.userId
        })
        .then((res) => {
          this[type] = res.data;
        })
        .catch((err) => {
          this[type] = "获取代码失败！";
          console.log(err);
        });
    },
    toPercent(val, bit) {
      return this.$util.tools.transformPercentNumber(val, bit);
    },
    handleNoCodeFile() {
      this.$message.info("暂无可下载的代码文件");
    },
  },
};
</script>
<style lang="less" scoped>
// .inner-gap(@gap:10px) {
//   margin-bottom: @gap;
// }
#strategy_detail {
  color: #666;
  position: relative;
  .det_wrapper {
    // width: 1400px;
  }
  .navigation {
    height: 62px;
    // width: 1400px;
    .current {
      color: #333;
      margin-right: 5px;
    }
    .ivu-breadcrumb {
      .ivu-breadcrumb-item-separator {
        margin: 0 5px !important;
      }
      .ivu-breadcrumb-item-link {
        color: #666;
      }
    }
  }
  .card {
    padding: 20px;
    margin-bottom: 20px;
    background-color: #fff;
  }
  .icon {
    font-size: 18px;
  }
  .strategy-desc {
    position: relative;
    padding: 20px;
    .title {
      // .inner-gap();
      font-size: 20px;
      font-weight: bold;
      color: rgba(17, 17, 31, 1);
    }
    .header {
      // .inner-gap();
      span {
        margin-right: 20px;
      }
      .date {
        margin-left: 4em;
      }
    }
    .content {
      margin: 20px 0;
      .title {
        // .inner-gap(8px);
        font-size: 16px;
      }
      p {
        line-height: 1.5;
        white-space: pre-line;
        word-break: break-word;
      }
    }
    .footer {
      text-align: right;
      color: rgba(152, 152, 152, 1);
      span {
        padding: 0 10px;
      }
    }
  }
  .strategy-profit {
    padding: 0;
    table {
      font-size: 14px;
      width: 100%;
      tr {
        height: 56px;
        color: #666;
      }
      td,
      th {
        text-align: center;
        vertical-align: middle;
        font-weight: 400;
      }
      thead tr {
        background-color: rgba(52, 72, 175, 0.2);
      }
    }
  }
  .strategy-trend {
    // width: 810px;
    height: 420px;
    #echart_wrapper {
      width: 100%;
      height: 100%;
    }
  }
  .strategy-code {
    position: relative;
    padding: 0;
    background-color: #222733;
    .code-header {
      position: relative;
      height: 44px;
      line-height: 44px;
      .tabs {
        color: rgba(150, 171, 186, 1);
        background: rgb(64, 69, 80);
        .tab {
          display: inline-block;
          min-width: 76px;
          padding: 0 10px;
          text-align: center;
          cursor: pointer;
          &.active {
            color: rgba(237, 242, 245, 1);
            background-color: #222733;
          }
        }
      }
    }
    .donwload {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      padding-right: 20px;
      color: #ddd;
    }
    .item-list {
      max-height: 500px;
      padding: 20px;
      overflow: auto;
      font-size: 14px;
      color: rgba(237, 242, 245, 1);
      .item {
        font-family: inherit;
        display: none;
        &.show {
          display: block;
        }
      }
    }
  }
  .aside_wrapper {
    width: 360px;
    position: absolute;
    top: 62px;
    right: 0px;
  }
  .radarsCen {
    // width: 810px;
    padding: 20px;
    margin-bottom: 20px;
    height: 420px;
    background: #ffffff;
    .title {
      margin-bottom: 10px;
      font-size: 20px;
      font-weight: bold;
      color: #11111f;
      margin: 10px 0px;
    }
    .content .title {
      margin-bottom: 8px;
      font-size: 16px;
    }
    .header span {
      margin-right: 20px;
    }
  }
}
</style>
